module.exports = __webpack_public_path__ + "img/dq-answer-feed.8657c956.png";